export default "__VITE_PUBLIC_ASSET__16665acc__"